import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { ConfirmDialogConfig, DialogResult } from '../../../interfaces/dialog.interface';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmDialogComponent {
  readonly data = inject<ConfirmDialogConfig>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<ConfirmDialogComponent>);

  constructor() {
    if (!this.data.confirmText) this.data.confirmText = 'Confirmar';
    if (!this.data.cancelText) this.data.cancelText = 'Cancelar';
    if (!this.data.icon) this.data.icon = 'help';
  }

  onConfirm(): void {
    const result: DialogResult = { confirmed: true };
    this.dialogRef.close(result);
  }

  onCancel(): void {
    const result: DialogResult = { confirmed: false };
    this.dialogRef.close(result);
  }
}
